import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import ifiLogo from './assests/IFI-Logo-mobile-standard.png';
import { breakpoint } from './assests/style';

export const Logo = styled.img`
  @media only screen and (max-width: ${breakpoint.medium}px) {
    width: ${(props) => props.theme.size.width};
  }
`;

export const IFILogo = (props) => {
  const { size } = props;
  
  return (
    <ThemeProvider theme={{ size }}>
      <Logo src={ifiLogo} alt="International Friendships, Inc (IFI) Logo" />
    </ThemeProvider>
  );
};
